export default __webpack_public_path__ + "b9408c436ba6211a60328988d675b0ee.png";